import type { ApiResponse } from "../factory";
import { BaseRepository } from "../factory";

export interface Review {
  id: number;
  file_id: number;
  title: string;
  description: string;
  created_at: string;
  updated_at: string;
  breadcrumbs: {
    label: string;
    url: string;
  }[];
  file: {
    data:
      | {
          id: number;
          title: string;
          type: string;
          ext: string;
          description: string | null;
          url: string;
          alt: string | null;
          caption: string | null;
          created_at: string;
          updated_at: string;
        }
      | [];
  };
  seo: {
    data: {
      id: number;
      title: string | null;
      description: string | null;
      author: string | null;
      robots: string | null;
    };
  };
}

export class ReviewsRepository extends BaseRepository<Review> {
  collection = "reviews";
  language?: string;

  constructor(language?: string) {
    super();
    this.language = language;
  }

  getMany(
    queryParams?: Record<string, unknown>
  ): Promise<ApiResponse<Review[]>> {
    return super.getMany(queryParams);
  }
}
